import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import { useParams } from "react-router-dom";
import queryFn from "ApiLayer/BuildingReports/Baseline/queryAnnualCarbonEmissionsElectricityChart";

export const useAnnualCarbonEmissionsElectricityChart = () => {
    const accessToken = useAccessToken();
    const { buildingModelCarbonReductionPlanId } = useParams();
    if (!buildingModelCarbonReductionPlanId) throw new Error("BuildingModelUid param needs to be defined");

    return useQuery({
        queryKey: [
            buildingModelCarbonReductionPlanId,
            "buildingModelReport",
            "buildingModelBaselineCarbonEmissionsElectricityChart",
        ],
        queryFn: async () => queryFn(accessToken, buildingModelCarbonReductionPlanId),
        staleTime: QUERY_STALE_TIME,
    });
};
